import React from 'react';
import { SectionListBase, SectionListGrid } from './styled';

interface SectionListProps {
  children?: React.ReactNode;
  forwardedRef?: React.Ref<HTMLDivElement>;
  isNewDesign?: boolean;
  isVipPage?: boolean;
  isMainVipPage?: boolean;
}

export const SectionList: React.FC<SectionListProps> = ({
  children,
  forwardedRef,
  isNewDesign,
  isVipPage,
  isMainVipPage
}) =>
  isNewDesign ? (
    <SectionListGrid
      ref={forwardedRef}
      $isVipPage={isVipPage}
      $isMainVipPage={isMainVipPage}
    >
      {children}
    </SectionListGrid>
  ) : (
    <SectionListBase
      ref={forwardedRef}
      $isVipPage={isVipPage}
      $isMainVipPage={isMainVipPage}
    >
      {children}
    </SectionListBase>
  );
